import { yupResolver } from '@hookform/resolvers/yup';
import { IBankPromotorFormMeta } from '@Modules/admin/basicSettings/containers/formHandlers/bank/BankPromotorFormHandler/BankPromotorFormMeta';
import { CustomButton } from '@Modules/core/components';
import CustomFormControl from '@Modules/core/components/form/CustomFormControl';
import CustomInput from '@Modules/core/components/form/CustomInput';
import AppLoader from '@Modules/core/components/Loader';
import { ChakraComponents as CC } from '@Modules/core/lib/chakra';
import { useForm } from 'react-hook-form';

type Props = {
  onSubmit: any,
  meta: IBankPromotorFormMeta,
  isLoading: boolean,
  isSubmitting: boolean,
};

export default function BankPromotorFormUI({
  onSubmit,
  meta,
  isLoading,
  isSubmitting,
}: Props) {
  const {
    register,
    handleSubmit,
    formState: { errors },
    // reset,
  } = useForm({ resolver: yupResolver(meta.schema) });

  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)}>
        <CC.Box>
          <CC.Text mb="4" color="gray.600">
            {/* Remplissez les informations de base du profile */}
            {isLoading && <AppLoader />}
          </CC.Text>

          <CC.Box w="full" mt="4" mb="8">
            <CC.Flex
              flexDirection={{ base: 'column', md: 'row' }}
              w="full"
              mb="4"
            >
              <CustomFormControl
                isInvalid={!!errors[meta.title.name]}
                label={meta.title.label}
              >
                <CustomInput
                  meta={meta.title}
                  register={register(meta.title.name)}
                  hasError={errors[meta.title.name]}
                />
              </CustomFormControl>

              <CustomFormControl
                isInvalid={!!errors[meta.firstName.name]}
                label={meta.firstName.label}
                mx={{ md: '2' }}
              >
                <CustomInput
                  meta={meta.firstName}
                  register={register(meta.firstName.name)}
                  hasError={errors[meta.firstName.name]}
                />
              </CustomFormControl>

              <CustomFormControl
                isInvalid={!!errors[meta.lastName.name]}
                label={meta.lastName.label}
              >
                <CustomInput
                  meta={meta.lastName}
                  register={register(meta.lastName.name)}
                  hasError={errors[meta.lastName.name]}
                />
              </CustomFormControl>
            </CC.Flex>

            <CC.Flex
              w="full"
              mb="4"
              flexDirection={{ base: 'column', md: 'row' }}
            >
              <CustomFormControl
                isInvalid={!!errors[meta.moyen.name]}
                label={meta.moyen.label}
              >
                <CustomInput
                  meta={meta.moyen}
                  register={register(meta.moyen.name)}
                  hasError={errors[meta.moyen.name]}
                />
              </CustomFormControl>

              <CustomFormControl
                isInvalid={!!errors[meta.birthDate.name]}
                label={meta.birthDate.label}
                mx={{ md: '2' }}
              >
                <CustomInput
                  meta={meta.birthDate}
                  register={register(meta.birthDate.name)}
                  hasError={errors[meta.birthDate.name]}
                />
              </CustomFormControl>

              <CustomFormControl
                isInvalid={!!errors[meta.birthPlace.name]}
                label={meta.birthPlace.label}
              >
                <CustomInput
                  meta={meta.birthPlace}
                  register={register(meta.birthPlace.name)}
                  hasError={errors[meta.birthPlace.name]}
                />
              </CustomFormControl>
            </CC.Flex>

            <CC.Flex
              w="full"
              mb="4"
              flexDirection={{ base: 'column', md: 'row' }}
            >
              <CustomFormControl
                isInvalid={!!errors[meta.firstIdentity.name]}
                label={meta.firstIdentity.label}
              >
                <CustomInput
                  meta={meta.firstIdentity}
                  register={register(meta.firstIdentity.name)}
                  hasError={errors[meta.firstIdentity.name]}
                />
              </CustomFormControl>

              <CustomFormControl
                isInvalid={!!errors[meta.secondIdentity.name]}
                label={meta.secondIdentity.label}
                mx={{ md: '2' }}
              >
                <CustomInput
                  meta={meta.secondIdentity}
                  register={register(meta.secondIdentity.name)}
                  hasError={errors[meta.secondIdentity.name]}
                />
              </CustomFormControl>

              <CustomFormControl
                isInvalid={!!errors[meta.identityType.name]}
                label={meta.identityType.label}
              >
                <CustomInput
                  meta={meta.identityType}
                  register={register(meta.identityType.name)}
                  hasError={errors[meta.identityType.name]}
                />
              </CustomFormControl>

              <CustomFormControl
                isInvalid={!!errors[meta.identityType2.name]}
                label={meta.identityType2.label}
                ml={{ md: '2' }}
              >
                <CustomInput
                  meta={meta.identityType2}
                  register={register(meta.identityType2.name)}
                  hasError={errors[meta.identityType2.name]}
                />
              </CustomFormControl>
            </CC.Flex>

            <CC.Flex
              w="full"
              mb="4"
              flexDirection={{ base: 'column', md: 'row' }}
            >
              <CustomFormControl
                isInvalid={!!errors[meta.sex.name]}
                label={meta.sex.label}
              >
                <CustomInput
                  meta={meta.sex}
                  register={register(meta.sex.name)}
                  hasError={errors[meta.sex.name]}
                />
              </CustomFormControl>

              <CustomFormControl
                isInvalid={!!errors[meta.materimonialeSituation.name]}
                label={meta.materimonialeSituation.label}
                mx={{ md: '2' }}
              >
                <CustomInput
                  meta={meta.materimonialeSituation}
                  register={register(meta.materimonialeSituation.name)}
                  hasError={errors[meta.materimonialeSituation.name]}
                />
              </CustomFormControl>

              <CustomFormControl
                isInvalid={!!errors[meta.citizen.name]}
                label={meta.citizen.label}
              >
                <CustomInput
                  meta={meta.citizen}
                  register={register(meta.citizen.name)}
                  hasError={errors[meta.citizen.name]}
                />
              </CustomFormControl>

              <CustomFormControl
                isInvalid={!!errors[meta.numberChildren.name]}
                label={meta.numberChildren.label}
                ml={{ md: '2' }}
              >
                <CustomInput
                  meta={meta.numberChildren}
                  register={register(meta.numberChildren.name)}
                  hasError={errors[meta.numberChildren.name]}
                />
              </CustomFormControl>
            </CC.Flex>
          </CC.Box>

          <CC.Flex justify={'flex-end'}>
            <CustomButton isLoading={isSubmitting} type="submit" >
              Sauvegarder
            </CustomButton>
          </CC.Flex>
        </CC.Box>
      </form>
    </>
  );
}
